export const PropertyType = {
  residential: 'residential',
  commercial: 'commercial',
  mixed: 'mixed',
  land: 'land',
};

export const PropertyTypeLabel = {
  [PropertyType.residential]: 'Residential',
  [PropertyType.commercial]: 'Commercial',
  [PropertyType.mixed]: 'Mixed-Use',
  [PropertyType.land]: 'Land',
};

export const Approach = {
  income: 'income',
  sales: 'sales',
} as const;

export const VALUE_CONCLUSION_TYPES = {
  AS_IS: 'asIs',
  AS_STABILIZED: 'asStabilized',
  AS_COMPLETE: 'asComplete',
};

export const ValueConclusionOptions = [
  { label: 'As Is', value: VALUE_CONCLUSION_TYPES.AS_IS },
  { label: 'As Stabilized', value: VALUE_CONCLUSION_TYPES.AS_STABILIZED },
  { label: 'As Complete', value: VALUE_CONCLUSION_TYPES.AS_COMPLETE },
];

export const IncomeType = {
  residential: 'residential',
  commercial: 'commercial',
  residentialAndCommercial: 'residentialAndCommercial',
} as const;

export const IncomeTypeOptions = [
  { label: 'Residential', value: IncomeType.residential },
  { label: 'Commercial', value: IncomeType.commercial },
  { label: 'Both', value: IncomeType.residentialAndCommercial },
];

export const CompplexCompStatusLabel: { [key in string]: string } = {
  draft: 'Draft',
  confirmed: 'Confirmed',
  verified: 'Verified',
  doNotUse: 'Do Not Use',
};

export const CompplexCompStatusColor: { [key in string]: string } = {
  draft: '#EEEEEE',
  confirmed: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #FFC355',
  verified: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #20B586',
  doNotUse: 'rgba(211, 65, 65, 0.08)',
};

export const DISABLE_TABLE_NUMBER_INPUT_CONTROLS_SX = {
  '& .MuiDataGrid-cell input[type="number"]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& .MuiDataGrid-cell input[type="number"]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& .MuiDataGrid-cell input[type="number"]': {
    '-moz-appearance': 'textfield',
  },
};
